import { ServerNotificationInterface } from "@/api/Notifications/List/Interfaces/ServerNotificationInterface";
import { RootState } from "@/store/Store";
import { createSlice, PayloadAction, } from "@reduxjs/toolkit";

export interface NotificationInterface {
    id: number,
    // title: string,
    body: string,
    received: string,
    unread: boolean,
}

export interface PaginationInterface {
    currentPage: number,
    totalPages: number,
}

export interface NotificationsStateInterface {
    notifications: NotificationInterface[],
    pagination: PaginationInterface,
}

function getInitialState(): NotificationsStateInterface {
    return {
        notifications: [],
        pagination: {
            currentPage: 1,
            totalPages: 1,
        }
    };
}

const NotificationsSlice = createSlice({
    name: "NotificationsSlice",
    initialState: getInitialState(),
    reducers: {
        prependNotification: (state, action: PayloadAction<NotificationInterface>) => {
            state.notifications.unshift(action.payload);
        },
        setNotificationRead: (state, action: PayloadAction<NotificationInterface["id"]>) => {
            state.notifications = state.notifications.map(unit => {
                if (unit.id !== action.payload) {
                    return unit;
                }
                const modified = {...unit, unread: false};
                return modified;
            })
        },
        setNotifications: (state, action: PayloadAction<ServerNotificationInterface[]>) => {
            state.notifications = action.payload.map(unit => ({
                id: unit.id,
                title: "",
                body: unit.data,
                received: unit.created_at,
                unread: unit.viewed === 0,
            }))
        },
        setTotalPages: (state, action: PayloadAction<PaginationInterface["totalPages"]>) => {
            state.pagination.totalPages = action.payload;
        },
        setCurrentPage: (state, action: PayloadAction<PaginationInterface["currentPage"]>) => {
            state.pagination.currentPage = action.payload;
        },
    },
});

export const {
    prependNotification,
    setNotificationRead,
    setNotifications,
    setTotalPages,
    setCurrentPage,
} = NotificationsSlice.actions;

export const getSelectorFor = (name: keyof NotificationsStateInterface) => (state: RootState) => state.notifications[name];

export const NotificationsReducer = NotificationsSlice.reducer;

